import gql from 'graphql-tag';

export const GET_TRAFFICKING_CUSTOM_FILTER = gql`
  query GET_TRAFFICKING_CUSTOM_FILTER($id: ID!) {
    traffickingCustomFilter(id: $id) {
      id
      filterName
      filterType
      visibility
      filterPayload
      createdBy
    }
  }
`;
